const barChartOptions = {
  scaleShowVerticalLines: false,
  responsive: true
};
const barChartLabels = ['Postulante 1', 'Postulante 2', 'Postulante 3', 'Postulante 4', 'Postulante 5', 'Postulante 6', 'Postulante 7', 'Postulante 8'];
const barChartType = 'bar';
const barChartData = [
  { data: [65, 59, 80, 81, 56, 55, 40, 10, 5], label: 'Eleccion 2021' }
];

const barChartColors = [
  {
    backgroundColor: '#2f61d7',
    borderColor: '#fc8b37',
    pointBackgroundColor: '#fc8b37',
    pointBorderColor: '#fc8b37',
    pointHoverBackgroundColor: '#fc8b37',
    pointHoverBorderColor: '#fc8b37'
  },
  {
    backgroundColor: '#7cdb86',
    borderColor: '#7cdb86',
    pointBackgroundColor: '#7cdb86',
    pointBorderColor: '#7cdb86',
    pointHoverBackgroundColor: '#7cdb86',
    pointHoverBorderColor: '#7cdb86'
  }
];

export default {
  data: {
    labels: barChartLabels,
    datasets: barChartData,
    type: barChartType
  },
  options: barChartOptions
};
